import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Route } from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";
import { Grid, Tooltip } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import BiztranControls from "../../biztran_controls/BiztranControls";
import { Link, useLocation } from 'react-router-dom';
import ModalFrame from "../../biztran_controls/Modal_Frame";
import UseFetchData from "../../../hooks/UseFetchData";
import CreateAccount from "./CreateAccount";
// import Loader from "../../biztran_controls/Loader";


const Account = () => {
  //const [viewPath,setviewPath] = useState('')
  const [AccountID, setAccountID] = useState('');
  const [staName, setStaName] = useState('');
  const [AccName, setAccName] = useState('');
  const [StateName, setStateName] = useState('');
  const [StateID, setStateID] = useState('');
  const [GSTIN, setGSTIN] = useState('');
  // const [AccGroup, setAccGroup] = useState('');
  const [IndustryID, setIndustryID] = useState('');
  const [AccountGroupID, setAccountGroupID] = useState(sessionStorage.AccountGroupID);
  const [AccountGroup, setAccountGroup] = useState('');
  const [AccountOptions, setAccountOptions] = useState([]);
  const [StateOptions, setStateOptions] = useState([]);
  const [City, setCity] = useState('');
  const [State, setState] = useState('');
  const [CountryID, setCountryID] = useState('');
  const [Count, setCount] = useState();
  const [AccountName, setAccountName] = useState();
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [Industrycmb, setIndustrycmb] = useState([]);
  const [AccountGroupcmb, setAccountGroupcmb] = useState([]);
  const [Statecmb, setStatecmb] = useState([]);
  const [CountryIDcmb, setCountryIDcmb] = useState([]);
  const [isOpen, setOpen] = useState(false);
  const [SearchMode, setSearchMode] = useState("SEARCH");
  const [responseIndustry, fetchIndustryData] = UseFetchData();
  const [responseAccountGroup, fetchAccountGroupData] = UseFetchData();
  const [responseAccount, fetchAccountData] = UseFetchData();
  const [responseState, fetchStateData] = UseFetchData();
  const [responseCountry, fetchCountryData] = UseFetchData();
  // const [response, fetchData] = UseVSNJAPI();
  const [response, fetchData] = UseFetchData();
  const [SECountryID, setSECountryID] = useState();
  const [loading, setLoading] = useState(true);
  // const location = useLocation();



  const AccountGroupOption = [
    { id: "Export", title: "Export" },
    { id: "Domestic", title: "Domestic" },
  ];

  const handleOpenModal = () => {
    setOpen(true);
    setAccountID('');
  }

  const PopulateData = () => {
    var AccoName = "",
      AGroup = null,
      IndID = null,
      Citys = null,
      StaID = null,
      Coun = null,
      AcName = null;
    var bodyFormData = new FormData();
    if (AccountName !== undefined) {
      AccoName = AccountName.List;
    }
    if (AccountGroupID !== "") {
      AGroup = AccountGroupID;
    }
    if (IndustryID !== "") {
      IndID = IndustryID;
    }
    if (City !== "") {
      Citys = City;
    }
    if (StateID !== "") {
      StaID = StateID;
    }
    if (CountryID !== "") {
      Coun = CountryID;
    }
    if (AccName !== "") {
      AcName = AccName;
    }
    var bodyFormData = new FormData();
    setSearchMode(SearchMode);
    bodyFormData.append("UserID", sessionStorage.UID);
    bodyFormData.append("UserType", sessionStorage.UserType);
    bodyFormData.append("UserGroupID", sessionStorage.UserGroupID);
    bodyFormData.append("Email", sessionStorage.Email);
    if (sessionStorage.UserType == "Admin") {
      bodyFormData.append("AccountGroup", AccountGroup);
    }
    else {
      bodyFormData.append("AccountGroupID", AccountGroupID);
    }
    // if (AccountName == "" && location.state == undefined) {
    // }
    // else if (value == "SEARCH") {
    bodyFormData.append("AccountName", AccoName);
    // }
    // else if (location.state.Account != "" && location.state != undefined) {
    //   var AccountN = location.state.Account;
    //   bodyFormData.append("AccountName", AccountN);
    // }
    bodyFormData.append("IndustryID", IndustryID);
    bodyFormData.append("City", City);
    bodyFormData.append("StateID", StateID);
    bodyFormData.append("CountryID", CountryID);
    bodyFormData.append("GSTIN", GSTIN);
    bodyFormData.append("AccountTypeID", "");
    bodyFormData.append("SearchString", AccName);
    setLoading(true);
    fetchData("Account/List", bodyFormData);

  };


  const IndustryData = () => {
    var bodyFormData = new FormData();
    setLoading(true);
    fetchIndustryData("Account/ComboDataAccount", bodyFormData);
  }

  const StateData = () => {
    var bodyFormData = new FormData();
    fetchStateData("Account/ComboDataAccount", bodyFormData);
  }

  const CountryData = () => {
    var bodyFormData = new FormData();
    setLoading(true);
    fetchCountryData("Account/ComboDataAccount", bodyFormData);
  }

  const AccountData = () => {
    var bodyFormData = new FormData();
    setLoading(true);
    fetchAccountData("Account/ComboDataAccount", bodyFormData);
  }

  useEffect(() => {
    // AccGroupData();
    IndustryData();
    StateData();
    CountryData();
    AccountData();
  }, []);

  const onStateChange = (event, newValue) => {
    // debugger;
    setStateName(newValue);
    setStateID(newValue.id)
  }

  const onACCChange = (event, newValue) => {
    // debugger;
    setAccountName(newValue);
    setAccountID(newValue.id);
  }


  useEffect(() => {
    debugger;
    if (responseAccount['cmbAccount'] !== undefined && responseAccount['cmbAccount'].length > 0) {
      setLoading(false);
      setAccountOptions(responseAccount['cmbAccount']);
    }
  }, [responseAccount['cmbAccount']]);

  useEffect(() => {

    if (responseState['cmbState'] !== undefined && responseState['cmbState'].length > 0) {
      //// debugger;
      setLoading(false);
      setStateOptions(responseState['cmbState']);
    }
  }, [responseState['cmbState']]);

  useEffect(() => {
    if (responseCountry !== undefined) {
      //// debugger;
      // setLoading(false);
      if (responseCountry["cmbCountry"] !== undefined) {
        setCountryIDcmb(responseCountry["cmbCountry"]);
      }
    }
  }, [responseCountry]);



  useEffect(() => {
    if (responseIndustry !== undefined) {
      //// debugger;
      setLoading(false);
      if (responseIndustry["cmbIndustry"] !== undefined) {
        setIndustrycmb(responseIndustry["cmbIndustry"]);
      }
    }
  }, [responseIndustry]);



  useEffect(() => {
    // debugger;
    const gridCols = [
      {
        field: "id",
        headerName: ".",
        renderCell: (params) =>
          (<strong> <Link to={{ pathname: "/account/AccountView", state: { AccountID: params.id, AccountName: params.row.AccountName } }} style={{ color: 'blue' }} >Select</Link> </strong>),
        //renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong> ), 
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 70,
      },

    ];

    const copygridclm = gridCols.slice();
    var clm = {};
    if (response !== undefined && response.length > 0) {
      setLoading(false);
      for (var i = 1; i < Object.keys(response[0]).length; i++) {
        if (Object.keys(response[0])[i] !== "id") {
          clm = {
            field: Object.keys(response[0])[i],
            headerName: Object.keys(response[0])[i],
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            width: 200,
          };
        }
        copygridclm.push(clm);
      }
    }
    setColumns(copygridclm);
    setRows(response);
    setCount(response.length);
  }, [response]);


  useEffect(() => {
    PopulateData();
  }, [])



  return (
    <div>
      {/* {
        loading && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 10,
          }}>
            <Loader />
          </div>
        )
      } */}
      <Grid container direction="row" spacing={2} >
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 10, paddingTop: 0, paddingBottom: 0, marginRight: 40 }}>
          <BiztranControls.Autocomplete
            label="Account Name"
            style={{ marginLeft: 8, width: "250px" }}
            options={AccountOptions}
            onChange={onACCChange}
            value={AccName}>
          </BiztranControls.Autocomplete>
        </Grid>
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: -5 }} >
          {/* <BiztranControls.Select
            label="Account Group"
            id="accGroup"
            style={{ width: 'maxWidth' }}
            options={AccountGroupcmb}
            onChange={(e) => setAccountGroupID(e.target.value)}
            value={AccountGroupID}
          /> */}
          <BiztranControls.Select
            label="Account Group"
            id="accGroup"
            width="180px"
            options={AccountGroupOption}
            onChange={(e) => setAccountGroup(e.target.value)}
          />
        </Grid>
        {/* <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 12, paddingTop: 0, paddingBottom: 0, marginLeft: 55 }}> */}
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: -5 }} >
          <BiztranControls.Select
            label="Industry"
            id="industry"
            style={{ width: 'maxWidth' }}
            options={Industrycmb}
            onChange={(e) => setIndustryID(e.target.value)}
          />
        </Grid>
        {/* <Grid item xs={12} sm={4} md={3} lg={2} xl={2} > */}
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: -5 }} >
          <BiztranControls.Input
            label="GSTIN"
            id="GSTIN"
            style={{ width: 'maxWidth' }}
            onChange={(e) => setGSTIN(e.target.value)}
          />
        </Grid>
      </Grid>
      <Grid container direction="row" style={{ marginTop: 20 }}>
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 0, paddingTop: 0, paddingBottom: 0, marginRight: 40 }}>
          <BiztranControls.Select
            label="Country"
            id="Country"
            style={{ width: 'maxWidth' }}
            options={CountryIDcmb}
            //onChange={onSelectChange}
            onChange={(e) => setCountryID(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2} lg={2} xl={2} style={{ marginTop: 9, marginLeft: 8 }}>
          <BiztranControls.Autocomplete
            label="State Name"
            style={{ width: '180px' }}
            options={StateOptions}
            onChange={onStateChange}
            value={State}>
          </BiztranControls.Autocomplete>
        </Grid>
        <Grid item xs={12} sm={6} md={2} lg={2} xl={2}  >
          <BiztranControls.Input
            label="City"
            id="city"
            style={{ width: 'maxWidth' }}
            onChange={(e) => setCity(e.target.value)}
          />
        </Grid>
        {/* <Grid xs={6} md={4} sm={8} lg={4} xl={3} > */}
        <Grid container xs={12} sm={12} md={6} lg={4} xl={2} direction="row" >
          <Grid item>
            <BiztranControls.Button
              text="SEARCH"
              startIcon={<SearchIcon />}
              onClick={() => {
                PopulateData('SEARCH');
              }}
            />
          </Grid>
          <Grid item style={{ marginTop: 8 }}>
            <label style={{ fontWeight: 'bold', width: 30 }}>{Count}</label>
          </Grid>
          <Grid item>
            <BiztranControls.Button
              text="ADD NEW"
              startIcon={<AddCircleOutlineIcon />}
              onClick={() => {
                handleOpenModal();
              }}
            />

          </Grid>
        </Grid>
      </Grid>
      <BiztranControls.DataGrid
        rowHeight={25}
        headerHeight={34}
        rows={rows}
        columns={columns}
        checkboxSelection={false}
        // autoHeight={true}
        Height="500px"
        Width="100%"
      />
      <ModalFrame
        title="Account Details"
        maxWidth="md"
        isOpen={isOpen}
        headerAlign="center"
        setOpen={setOpen}
      >
        <CreateAccount
          AccountID={AccountID}
          setOpen={setOpen}
          // getByIDData={PopulateData}
          PopulateData={PopulateData}
        />
      </ModalFrame>
    </div>
  );
};



export default Account;
